import React from 'react';

import { Auth } from 'aws-amplify';
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid';

import UsernameHandler from './AuthParts/UsernameHandler';
import PasswordHandler from './AuthParts/PasswordHandler';
import NewPasswordHandler from './AuthParts/NewPasswordHandler';
import PasswordResetHandler from './AuthParts/PasswordResetHandler';
import ErrorHandler from './AuthParts/ErrorHandler';

class Authentication extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authState: "username_required",
        }
    }

    renderAuthState = () => {
     
        const { authState, username, user, errorType, ccEmail, helpText } = this.state;
        switch (authState) {
            case 'username_required':
                return <UsernameHandler classes={this.props.classes} onStateChange={this.handleStateChange} />;
            case 'temp_password_required':
                return <PasswordHandler classes={this.props.classes} placeholder="Enter temporary password" username={username} onStateChange={this.handleStateChange} />;
            case 'password_required':
                return <PasswordHandler classes={this.props.classes} placeholder="Enter password" allowReset username={username} onStateChange={this.handleStateChange} />;
            case 'new_password_required':
                return <NewPasswordHandler classes={this.props.classes} user={user} onStateChange={this.handleStateChange} />;
            case 'self_signup_prohibited':
                return <ErrorHandler classes={this.props.classes} username={username} errorType={errorType} ccEmail={ccEmail} helpText={helpText} onStateChange={this.handleStateChange} />;
            case 'self_signup_required':
                return <ErrorHandler classes={this.props.classes} username={username} errorType={'Self signup not enabled'} helpText={'Self signup is not currently available, please contact support to organise account setup'} onStateChange={this.handleStateChange} />;
            case 'user_signin_complete':
                return null;
            case 'password_reset_requested':
                return <PasswordResetHandler classes={this.props.classes} username={username} onStateChange={this.handleStateChange} />
            default:
                return authState;
        }
    }

    handleStateChange = (authState, additional) => {
        this.setState({ authState, ...additional }, () => {
            if (authState === 'user_signin_complete') {
                this.props.onStateChange('signedIn')
            }
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid className={classes.loginPage} container spacing={0}>
                <Grid item xs />
                <Grid container item md={5} alignItems="center" justify="center" className={classes.loginPanel} >
                    <Grid item md={9}>
                        {
                            this.renderAuthState()
                        }
                    </Grid>
                </Grid>
            </Grid >)
    }
}

export default withStyles(theme => ({
    loginPage: {
        background: "url('https://cdn.annalect.nz/system-images/connect/backgrounds/annalect-connect-background.jpg') left center no-repeat",
        backgroundAttachment: 'fixed'
    },
    loginPanel: {
        background: '#fff'
    },
    cardElement: {
        maxWidth: 450
    },
    logoAvatar: {
        height: 30,
        marginTop: 8
    },
    loadingAvatar: {
        height: 30,
        marginTop: 8,
        animation: 'logo-spin infinite 5s linear'
    },
    cardHeader: {
        paddingBottom: 0
    },
    signInActions: {
        paddingLeft: theme.spacing.unit * 3,
        paddingRight: theme.spacing.unit * 3
    },
    spacer: {
        flex: 1
    },
    info: {
        border: '1px solid ' + theme.palette.info.dark,
        background: theme.palette.info.light,
        padding: theme.spacing.unit * 3,
        color: theme.palette.info.main,
    },
    success: {

        border: '1px solid ' + theme.palette.success.dark,
        background: theme.palette.success.light,
        padding: theme.spacing.unit * 3,
        color: theme.palette.success.main,
    },
    error: {
        border: '1px solid ' + theme.palette.error.dark,
        background: theme.palette.error.light,
        padding: theme.spacing.unit * 3,
        color: theme.palette.error.main,
    },
    iconButtonAddornment: {
        height: 30,
        width: 30
    }
}), { withTheme: true })(Authentication);


// WEBPACK FOOTER //
// ./src/Components/Authentication/index.js